export const it = {
  creditsDomain: {
    dialogCreditsUser: {
      title: 'Crediti',
      progress: {
        title: 'Crediti residui: {{credits}}',
        totalCredits: 'crediti totali',
        nextRecharge: 'Prossimo rinnovo: {{date}}',
      },
      howToWork: {
        title: 'Come funziona?',
        description:
          'Ogni mese ricevi 1.000 crediti per accedere a corsi, contenuti e attività. Ogni trimestre, i crediti non utilizzati vengono azzerati automaticamente. ',
      },
    },
  },
};
